import moment from 'moment-timezone';

import { IPolicyVehicle, IVehicle, ERegionCode } from '../../interfaces';

const currentYear = Number(moment.utc().format('YYYY'));

const regionBasedRules = {
  oemParts: (regionCode: ERegionCode, vehicleAge: number) => {
    switch (regionCode) {
      case 'TN':
        return vehicleAge < 2 || vehicleAge > 10;
      default:
        return vehicleAge > 10;
    }
  },
};

export function getHiddenVehicleCoverageFields(
  vehicle:
    | IVehicle
    | IPolicyVehicle
    | (Partial<IPolicyVehicle> & Pick<IPolicyVehicle, 'garage_address'>),
  {
    isHideRidesharing = false,
    baseVehicleYear = currentYear,
  }: { isHideRidesharing?: boolean; baseVehicleYear?: number } = {}
) {
  const regionCode = vehicle.garage_address.region.code;
  const vehicleAge = Math.max(
    baseVehicleYear - (vehicle?.year || currentYear),
    0
  );
  const isOwned = vehicle?.ownership_status === 'owned';

  const hiddenVehicleCoverages = [];

  if (!vehicle.year || vehicleAge > 1) {
    hiddenVehicleCoverages.push('new_car_replacement');
  }

  if (!vehicle.year || vehicleAge > 3 || isOwned) {
    hiddenVehicleCoverages.push('loan_lease_payoff');
    hiddenVehicleCoverages.push('gap');
  }

  if (isHideRidesharing) {
    hiddenVehicleCoverages.push('ridesharing');
    hiddenVehicleCoverages.push('side_hustle');
  }

  if (!vehicle.year || regionBasedRules.oemParts(regionCode, vehicleAge)) {
    hiddenVehicleCoverages.push('oem_parts');
  }

  return hiddenVehicleCoverages;
}
